import { render } from "./IndustrySectorCell.vue?vue&type=template&id=570e5cc6&scoped=true"
import script from "./IndustrySectorCell.vue?vue&type=script&lang=js"
export * from "./IndustrySectorCell.vue?vue&type=script&lang=js"

import "./IndustrySectorCell.vue?vue&type=style&index=0&id=570e5cc6&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570e5cc6"]])

export default __exports__